import type { SellerLead } from 'shared/helpers/QualificationContext';

/**
 * A convenience method to extract deeply nested contact info
 * in a safe way.
 */
export const getLeadInfo = (
  lead?: SellerLead | null,
): {
  email: string | undefined;
  phone: string | undefined;
  name: string;
  customerUUID: string;
} => ({
  email: lead?.customerV2?.primaryEmail?.address?.value,
  phone: lead?.customerV2?.primaryPhoneNumber?.number?.value,
  name: lead?.customerV2?.fullName || '',
  customerUUID: lead?.customerV2?.uuid || '',
});
